import classNames from 'classnames'
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import {
  AiCreateArtworkModel,
  AiCreateArtworkPattern,
  getAIPrompt_pictureGraph_aiCreateArtworkOptionMenu_promptTipsOptions,
  GPTVisibleState,
  reportPV,
  reportPVVariables,
} from '~/graphqls/types'
import styles from './AiForm.module.css'
import InputArea from '~/components/pages/ai/InputArea'
// import { isControlnetPattern } from '~/configs/lab'
import { ChatGPTContent } from './ChatGPTContent'
import { ChatGPTPopup } from './ChatGPTPopup'
import { useMutation } from '@apollo/client'
import router from 'next/router'
import { useAuth } from '~/hooks/useAuth'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { useStores } from '~/hooks/useStores'
import Cookies from 'js-cookie'
import { MyForm } from '~/components/ui/MyForm'
import { REPORT_PV } from '~/graphqls/gqls'
import { CDNImage } from '~/components/ui/CDNImage'

export const Prompt: React.FC<{
  prompts: getAIPrompt_pictureGraph_aiCreateArtworkOptionMenu_promptTipsOptions[]
  onRefreshPrompts: () => void
  promptOptimize: boolean
  setPromptOptmize: Dispatch<SetStateAction<boolean>>
  selectModel: AiCreateArtworkModel
  toTagGen: () => void
  pattern?: AiCreateArtworkPattern
  onResult: (text: string) => void
  gptVisibleState: GPTVisibleState
  setGptVisibleState: Dispatch<SetStateAction<GPTVisibleState>>
}> = ({
  prompts,
  onRefreshPrompts,
  promptOptimize,
  setPromptOptmize,
  selectModel,
  toTagGen,
  pattern = AiCreateArtworkPattern.GENERAL,
  onResult,
  gptVisibleState = GPTVisibleState.idle,
  setGptVisibleState,
}) => {
  /** 画面描述placeholder */
  const promptPlaceholder = useMemo(() => {
    // if (isControlnetPattern(pattern)) {
    //   return '输入画面描述，支持中英文等语言输入'
    // }
    if (pattern === AiCreateArtworkPattern.MASK) {
      return '输入画面描述生成的内容会替代涂抹区域的画面，当未输入或只输入“修复”两个字会将涂抹区域进行自动修复'
    }
    if (selectModel === AiCreateArtworkModel.ANIME_DIFFUSION) {
      return '画面描述以短句、短语为佳，高级设置内的参数会对图像生成有艺术修饰作用；支持中英文等语言输入'
    }
    return '画面描述以短句、短语为佳，画面类型和高级设置内的参数会对图像生成有艺术修饰作用；支持中英文等语言输入'
  }, [selectModel, pattern])

  const { store } = useStores()
  const { validateIsLogin } = useValidateAuth()
  const { isLogin } = useAuth()
  const HOST = process.env.NEXT_PUBLIC_HOST
  const [popVisible, setPopVisible] = useState(false)
  //自动键入完成后textArea自动底部
  const [autoBottom, setaAtoBottom] = useState(false)
  //用户输入的内容获取gpt描述使用
  const [popContent, setPopContent] = useState('')
  const [isEnglish, setIsEnglish] = useState(false)

  // gpt点击上报
  const [getReportPVAction] = useMutation<reportPV, reportPVVariables>(
    REPORT_PV
  )

  useEffect(() => {
    const taskId = Cookies.get('gptTaskId') ?? ''
    const uidSame = taskId.split('_').filter(uid => {
      const tempId = store.userinfo?.base?.uid.toString ?? ''
      return uid === tempId
    })

    if (isLogin && uidSame) {
      if (taskId.length > 0) {
        setGptVisibleState(GPTVisibleState.loading)
      }
    }
    setaAtoBottom(false)
  }, [])

  const onReportGptTap = useCallback(() => {
    getReportPVAction({
      variables: {
        param: {
          channelId: 'ChatGPT_opt',
          page: HOST + router.asPath,
        },
      },
    })
  }, [])

  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="h-[30px] leading-[30px]">
          <span className="mr-[2px]">*</span>画面描述
        </div>
        <div className="flex">
          {true && selectModel === AiCreateArtworkModel.ANIME_DIFFUSION ? (
            <div
              className="relative bg-neutral-200 text-xs font-semibold py-1 px-3 rounded-full text-white"
              onClick={toTagGen}
            >
              <div>咒语生成器</div>
            </div>
          ) : null}
          {pattern == AiCreateArtworkPattern.GENERAL ? (
            <>
              <div
                className="relative bg-neutral-200 text-xs py-1 px-3 rounded-full ml-2"
                onClick={() => {
                  onReportGptTap()
                  setIsEnglish(false)
                  if (!validateIsLogin()) return
                  if (gptVisibleState == GPTVisibleState.idle) {
                    setPopVisible(true)
                  }
                }}
              >
                <div
                  className={
                    gptVisibleState != GPTVisibleState.idle
                      ? 'brightness-50 flex content-center'
                      : 'flex content-center'
                  }
                >
                  <CDNImage
                    src="/images/ai/chatgpt.svg"
                    className="w-5 h-5"
                    alt=""
                  />
                  <div className="ml-1 text-white font-semibold">ChatGPT</div>
                </div>
                <img
                  className="absolute h-[14px] -top-[6px] -right-2"
                  src="/images/new.png"
                  alt=""
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
      <MyForm.Item
        className={classNames(styles.borderLessFormItem, '!mb-8')}
        name="prompt"
        rules={[
          {
            required: true,
            message: '请输入画面描述',
          },
          { whitespace: true },
        ]}
      >
        {gptVisibleState != GPTVisibleState.idle &&
        pattern == AiCreateArtworkPattern.GENERAL ? (
          <div className="!h-[148px]">
            <ChatGPTContent
              gptVisibleState={gptVisibleState}
              setGptVisibleState={setGptVisibleState}
              keyText={popContent}
              model={selectModel}
              isEnglish={isEnglish}
              onResult={(value: string) => {
                onResult(value)
                setaAtoBottom(true)
              }}
            ></ChatGPTContent>
          </div>
        ) : (
          <InputArea
            onRefresh={() => onRefreshPrompts()}
            prompts={prompts}
            promptOptimize={promptOptimize}
            setPromptOptimize={setPromptOptmize}
            placeholder={promptPlaceholder}
            showSuggest={pattern === AiCreateArtworkPattern.GENERAL}
            rows={pattern !== AiCreateArtworkPattern.GENERAL ? 2 : undefined}
            autoBottom={autoBottom}
          />
        )}
      </MyForm.Item>
      <ChatGPTPopup
        visible={popVisible}
        setVisible={setPopVisible}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        onResult={(value: string) => {
          setPopContent(value)
          setGptVisibleState(GPTVisibleState.loading)
        }}
      ></ChatGPTPopup>
    </>
  )
}
